export default "__VITE_ASSET__Dn6Lf9RS__"